import { observer } from 'mobx-react';
import { Component } from 'react';
import { Icons } from 'src/assets/fonts/Icons/icons';
import { localeStore } from 'src/mobx/localesStore';
import Icon from 'src/view/components/Controls/Icon/Icon';
import CustomModalComponent from 'src/view/components/Controls/Modal/Modal';
import ModalBackground from 'src/view/components/Controls/Modal/ModalBackground/ModalBackground';
import { OrderStore } from '~/mobx/orderStore';
import { withOrderStore } from '~/view/screens/OrderScreen/context';
import './style.scss';

interface Props {
  isOpen: boolean;
  closeCancelDeliveryWarningModal: () => void;
  orderStore?: OrderStore;
}

// @ts-ignore
@withOrderStore
@observer
export default class CancelDeliveryWarningModal extends Component<Props, {}> {
  get orderStore() {
    return this.props.orderStore!;
  }

  render() {
    return (
      <CustomModalComponent
        isOpen={this.props.isOpen}
        onRequestClose={this.props.closeCancelDeliveryWarningModal}
        withCloseIcon={true}
        className="cancel-delivery-warning-modal"
        iconClassName="color-gray2"
      >
        <ModalBackground>
          <div className="cancel-delivery-warning-modal__container d-flex flex-column align-items-center">
            <Icon name={Icons.Warning} className="cancel-delivery-warning-modal__icon color-red mt-14" />
            <h1 className="family-semibold text-size-24 color-dark mt-8">{localeStore.t('request_delivery_not_cancel')}</h1>
            {this.orderStore.order?.takergo?.dsp_name ? (
              <div className="d-flex flex-row mt-5">
                <p className="family-semibold text-size-18 color-dark">{localeStore.t('please_contact')}</p>
                <span className="family-semibold text-size-18 color-mainblue">&nbsp;{this.orderStore.order?.takergo?.dsp_name}&nbsp;</span>
                <p className="family-semibold text-size-18 color-dark">{localeStore.t('for_more_details') + '.'} </p>
              </div>
            ) : (
              <p className="family-semibold text-size-24 color-dark mt-5">{localeStore.t('please_contact_your_dsp')}</p>
            )}
          </div>
        </ModalBackground>
      </CustomModalComponent>
    );
  }
}
